module.exports = __webpack_public_path__ + "static/media/ql-icon-info.d8039272.svg";